<script>
import { projectState } from "@app/store/projectStore.svelte.js";
import { explorerState } from "@app/store/explorerStore.svelte.js";
import { showModal } from "@app/store/modalStore.svelte.js";
import { environment } from "@app/store/envStore.svelte.js";
import Exit from "./items/Exit.svelte";
import Logout from "./items/Logout.svelte";
import OnlineSave from "./items/OnlineSave.svelte";
import OfflineSave from "./items/OfflineSave.svelte";
import Menu from "../menu/Menu.svelte";
import MenuItem from "../menu/MenuItem.svelte";
import MenuDivider from "../menu/MenuDivider.svelte";
import SubMenu from "../menu/SubMenu.svelte";
import WorkspacesMenu from "./WorkspacesMenu.svelte";
import * as m from "@app/paraglide/messages.js";

function openProjectModal() {
    explorerState.context = "load";
    showModal("storageExplorer");
}

function openRecentProjects() {
    explorerState.context = "load";
    showModal("recentProjects");
}

function toggleFullscreen() {
    if (document.fullscreenElement) {
        document.exitFullscreen();
    } else {
        document.documentElement.requestFullscreen();
    }
}
</script>

<Menu id="file" label={m.file()} ariaLabel={m.file_menu()}>
    <SubMenu label={m.new()} icon="bi-file-earmark-plus">
        <MenuItem
            label={m.project_ellipsis()}
            icon="bi-folder-plus"
            shortcut="New Project"
            onSelect={() => showModal("newProject")} />
        <MenuItem
            label={m.event_group_ellipsis()}
            icon="bi-collection"
            onSelect={() => showModal("newEventGroup")} />
    </SubMenu>

    {#if environment.online}
        <MenuItem
            label={m.open_project()}
            icon="bi-folder2-open"
            onSelect={openProjectModal} />
        <MenuItem
            label={m.open_recent()}
            icon="bi-clock-history"
            onSelect={openRecentProjects} />
    {:else}
        <MenuItem
            label={m.open_project()}
            icon="bi-folder2-open"
            onSelect={() => showModal("projectImport")} />
    {/if}

    <MenuDivider />
    {#if !environment.online || projectState.useLocalStorage}
        <OfflineSave />
    {:else}
        <OnlineSave />
    {/if}
    <MenuDivider />
    <MenuItem
        label={m.import_ellipsis()}
        icon="bi-download"
        shortcut="Import File"
        onSelect={() => showModal("fileImport")} />
    <MenuItem
        label={m.export_ellipsis()}
        icon="bi-upload"
        shortcut="Export File"
        onSelect={() => showModal("fileExport")} />
    <MenuItem
        label={m.batch_export()}
        icon="bi-files"
        shortcut="Batch Export"
        onSelect={() => showModal("batchSubtitleExport")} />
    <MenuDivider />
    <SubMenu label={m.view()} icon="bi-eye">
        {#if environment.electron}
            <MenuItem
                label={m.zoom()}
                icon="bi-zoom-in"
                onSelect={() => showModal("zoom")} />
            <MenuItem
                label={m.full_screen()}
                icon="bi-fullscreen"
                onSelect={toggleFullscreen} />
        {/if}
        <WorkspacesMenu nested />
    </SubMenu>
    <MenuDivider />
    <Logout />
    {#if environment.electron}
        <Exit />
    {/if}
</Menu>
